// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Blockframes
import { StatementShellComponent } from './statement-shell.component';
import { StatementPaymentModule } from '../statement-payment/statement-payment.module';

// Material
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [StatementShellComponent],
  exports: [StatementShellComponent],
  imports: [
    CommonModule,

    // Blockframes
    StatementPaymentModule,

    // Material
    MatSnackBarModule
  ],
})
export class StatementShellModule { }
